module.exports = __webpack_public_path__ + "img/error-500.cbadfed6.png";